import moment from 'moment';
import _ from 'underscore';

function Ctrl($rootScope, $scope, $state, $stateParams, $location, $timeout, partnerService, jsSdkEvent, utilsService, loggerService) {
  $scope.loading = true;
  $scope.events = [];

  $scope.citiesPromise
    .then(function() {
      const city = $stateParams.city;

      if (!city || city.length < 1) {
        $state.transitionTo('app.browse.events', {
          city: utilsService.defaultCitySlug()
        });
        return;
      }

      $scope.changeCity($stateParams.city);
    });

  $scope.changeCity = function(citySlug) {

    if (citySlug !== $stateParams.city) {
      $state.transitionTo('app.browse.events', {
        city: citySlug,
        tag: $stateParams.tag
      });
      return;
    }

    $scope.setCity(citySlug, function() {
      _getEvents();
    });
  };

  $scope.filters = [];

  function addFilter(tag) {
    if (!tag || !tag.key) return;

    tag.key = `USER_DEFINED_${tag.key}`.toUpperCase().replace(/ /g, '-');

    $scope.filters.push(tag);
  }

  _listTags();

  function _listTags() {
    let tags = [];

    if ($stateParams.tag) {
      tags.push($stateParams.tag);
    }

    if (partnerService.getTags()) {
      tags = tags.concat(partnerService.getTags());
    }

    if (tags && tags.length) {
      _.each(_.uniqBy(tags), function(tag) {
        addFilter({
          key: tag,
          name: tag,
          userDefined: true
        });
      });
    }
  }

  $scope.timeRanges = ['This Week', 'This Month', 'All Events'];

  const defaultTimeRange = ($scope.filters && $scope.filters.length > 0) ? 'All Events' : $scope.timeRanges[0];

  $scope.currentTimeRange = ($location.search() && $location.search().date) ? $location.search().date : defaultTimeRange;

  $scope.changeEventTimeRange = function(timeRange) {
    $location.search('date', timeRange);
    $scope.currentTimeRange = timeRange;
    _getEvents();
  };

  /*---------- Load Data -----------*/

  function _getEvents() {

    $scope.events = [];
    $scope.loading = true;

    const options = {
      fields: 'date,seoPathname,favoriteCount,name,images,venue(name,seoPathname,location.address),special,tags',
      cityId: $scope.city.id,
      sort: 'date',
      limit: 200
    };

    if ($scope.filters && $scope.filters.length > 0) {
      options.tags = $scope.filters[0].key;
    }

    const list = {
      'This Week': 7,
      'This Month': 30,
      'All Events': 365
    };

    const daysOut = list[$scope.currentTimeRange] || 30;

    options.start = moment().toDate().getTime();
    options.end = moment().add(daysOut, 'days').toDate().getTime();

    jsSdkEvent.listByCityId($scope.city.id, options).then(function _success(response) {
      $scope.events = response;

      $scope.loading = false;

      $timeout(function() {
        $rootScope.$broadcast('eventsLoaded');
      });

    }, function _error(response) {
      loggerService.error(response);
      $scope.loading = false;
    });
  }
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  '$state',
  '$stateParams',
  '$location',
  '$timeout',
  'partnerService',
  'jsSdk.event',
  'utilsService',
  'loggerService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/browseEvents/browseEventsCtrl.js